import React from 'react';
import {BrowserRouter, Route} from 'react-router-dom';

import { render } from 'react-dom';
import './scss/main.scss';

import Home from './components/home'
import Call from './components/call/index.js'

render(
    <BrowserRouter>
        <Route exact path="/" component={Home} />
        <Route path="/c/:id" component={(p) => <Call {...p} />} />
    </BrowserRouter>,
    document.getElementById('root')
);